import { jsx as l } from "react/jsx-runtime";
import { forwardRef as m } from "react";
import { IconButton as f } from "../IconButton/IconButton.js";
const n = m(
  ({ label: r, children: a, onToggle: e, checked: o, disabled: t, ...i }, c) => /* @__PURE__ */ l(
    f,
    {
      ariaLabel: r,
      role: "switch",
      "aria-checked": o ? "true" : "false",
      active: o,
      disabled: t,
      onClick: () => {
        e();
      },
      ref: c,
      ...i,
      children: a
    }
  )
);
n.displayName = "ToggleIcon";
export {
  n as ToggleIcon
};
//# sourceMappingURL=ToggleIcon.js.map
